// import Easing from '../lib/phaserEasings';
import Easing from '../constants/phaserEasings';
import { addToGameLoop, removeFromGameLoop } from './gameLoop';

const fps = (1 / 60) * 1000;
export function generateTweenData(
  startValue,
  endValue,
  duration,
  easing = Easing.Linear.None,
  reversed
) {
  let dt = 0;
  let data = [startValue];
  if (reversed) {
    duration /= 2;
  }
  let percent;
  do {
    dt += fps;
    dt = Math.min(dt, duration);
    percent = dt / duration;
    const easingValue = easing(percent);
    data.push(getCurrentValue(startValue, endValue, easingValue));
  } while (percent < 1);
  if (reversed) {
    const next = data.slice(0, -1);
    next.reverse();
    data = [...data, ...next];
  }
  return data;
}
export function startTweenData(target, tweenData, setter, onComplete, onIndex) {
  let index = 0,
    step = 1;
  loop();
  addToGameLoop(loop);
  return {
    stop() {
      removeFromGameLoop(loop);
    },
    shorten(factor) {
      if (factor <= 1) return;
      tweenData.length = Math.round(tweenData.length / factor);
    },
    accelerate(factor) {
      step = Math.round(factor);
    },
  };
  function loop() {
    if (index >= tweenData.length) {
      removeFromGameLoop(loop);
      if (onComplete) onComplete();
      return;
    }
    if (onIndex && index === onIndex.index) {
      onIndex.callBack.call(onIndex.context);
    }
    const currentValue = tweenData[index];
    if (Array.isArray(target)) target.forEach((t) => setter(t, currentValue));
    else setter(target, currentValue);
    index += step;
  }
}
export function startTweenLoop(target, tweenData, setter, reverse = false, onLoop) {
  let index = 0,
    last,
    elapsedFrames = 1;
  if (reverse) {
    const reversedData = [...tweenData].reverse().slice(1, -1);
    tweenData = [...tweenData, ...reversedData];
  }
  addToGameLoop(loop);
  return function () {
    removeFromGameLoop(loop);
  };
  function loop(timeStamp) {
    if (last !== undefined) {
      elapsedFrames = Math.max(Math.floor((timeStamp - last) / fps), 1);
    }
    last = timeStamp;
    const currentValue = tweenData[index];
    if (Array.isArray(target)) target.forEach((t) => setter(t, currentValue));
    else setter(target, currentValue);
    if (index + elapsedFrames >= tweenData.length && onLoop) onLoop();
    index = (index + elapsedFrames) % tweenData.length;
  }
}
function getCurrentValue(startValue, endValue, easingPercent) {
  if (typeof startValue === 'object') {
    const result = {};
    for (const pr in startValue) {
      result[pr] = getCurrentValue(startValue[pr], endValue[pr], easingPercent);
    }
    return result;
  }
  if (typeof startValue === 'string' && startValue.startsWith('#')) {
    startValue = colorStringToRGBObject(startValue);
    endValue = colorStringToRGBObject(endValue);
    const r = getCurrentValue(startValue, endValue, easingPercent);
    return rGBObjectToColorString(r);
  }
  return startValue + (endValue - startValue) * easingPercent;
}
function colorStringToRGBObject(color) {
  color = parseInt(color.slice(1), 16);
  return {
    r: (color >>> 16) & 0xff,
    g: (color >>> 8) & 0xff,
    b: color & 0xff,
  };
}
function rGBObjectToColorString(color) {
  return `#${colorComponentNumberToHexString(color.r)}${colorComponentNumberToHexString(
    color.g
  )}${colorComponentNumberToHexString(color.b)}`;
}
function colorComponentNumberToHexString(n) {
  return Math.round(n).toString(16).padStart(2, '0');
}
